import React from 'react';
import { message, Modal } from 'antd';

import { ApiError } from '../services/api';
import { logger } from '../services/logger';

class Notify {
  success(msg: string | React.ReactElement) {
    message.success(msg);
  }

  error(
    msg: string | React.ReactElement,
    error?: Error,
    context?: { [key: string]: any },
  ) {
    let logMessage = msg;

    if (context?.message) {
      logMessage = context.message;
      delete context.message;
    }

    if (error instanceof ApiError && error.userMessage) {
      msg += `: ${error.userMessage}`;
    }

    message.error(msg, 8);

    logger.error(String(logMessage), {
      ...context,
      error,
    });
  }

  alert({
    title,
    content,
    okText,
    type = 'warning',
  }: {
    title: string | React.ReactElement;
    content: string | React.ReactElement;
    okText?: string | React.ReactElement;
    type?: 'warning' | 'info' | 'error' | 'success';
  }): Promise<void> {
    return new Promise<void>((resolve) => {
      Modal[type]({
        title,
        content,
        okText,
        onOk: () => resolve(),
      });
    });
  }

  confirm({
    title,
    content,
    okText,
  }: {
    title: string | React.ReactElement;
    content: string | React.ReactElement;
    okText?: string | React.ReactElement;
  }): Promise<boolean> {
    return new Promise((resolve) => {
      Modal.confirm({
        title,
        content,
        okText,
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
  }
}

export const notify = new Notify();
